import React, { useState, useEffect } from 'react';
import './Feed.css';

export default function Feed() {
  const [itemsVisible, setItemsVisible] = useState([]);

  useEffect(() => {
    const items = document.querySelectorAll('.feed-item');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-up-and-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => {
      observer.observe(item);
    });

    return () => {
      items.forEach((item) => observer.unobserve(item));
    };
  }, []);

    return (
    <ol className="relative border-s border-gray-200 dark:border-gray-700 feed-item">
        <li className="mb-10 ml-4">
            <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
            <h3 className="text-lg font-semibold text-gray-900">Контактирајте нè</h3>
            <p className="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">И добиете консултација и поддршка од нашата страта.</p>
            <a href="/contact" className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-gray-100 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-gray-700">Контактирајте нè<svg className="w-3 h-3 ms-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
    </svg></a>
        </li>
        <li className="mb-10 ms-4">
            <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
            <h3 className="text-lg font-semibold text-gray-900">Добијте понуда</h3>
            <p className="text-base font-normal text-gray-500 dark:text-gray-400">Понуда зависност од комерцијални или домашни услуги.</p>
        </li>
        <li className="ms-4">
            <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
            <h3 className="text-lg font-semibold text-gray-900 ">Монтирање и испорачување на системите</h3>
            <p className="text-base font-normal text-gray-500 dark:text-gray-400">Брзо и ефикасно монтирање или испорачување на системите на лагер.</p>
        </li>
    </ol>
)
}